// GENERATED by scripts/generate-figure-index.mjs — do not edit. The figure
// index of every book: id, caption, section, printed page, web src.
export const BOOK_FIGURES = [
  {
    "book": "platform",
    "bookTitle": "The platform book",
    "id": "fig-platform-fractal-structure",
    "file": "fractal-structure.png",
    "src": "/docs/fractal-structure.png",
    "caption": "How the books expand — three zoom levels, the same shape inside every section",
    "section": "platform-how-this-book-expands",
    "sectionTitle": "How this book expands",
    "page": 5,
    "route": "/docs"
  },
  {
    "book": "platform",
    "bookTitle": "The platform book",
    "id": "fig-platform-platform-topology",
    "file": "platform-topology.png",
    "src": "/docs/platform-topology.png",
    "caption": "nventr.io control-plane topology — the Firebase plane",
    "section": "platform-platform-architecture",
    "sectionTitle": "Platform architecture",
    "page": 10,
    "route": "/docs"
  },
  {
    "book": "platform",
    "bookTitle": "The platform book",
    "id": "fig-platform-kit-topology",
    "file": "kit-topology.png",
    "src": "/docs/kit-topology.png",
    "caption": "App Kit instance topology — the Supabase plane (one compose project)",
    "section": "platform-platform-architecture",
    "sectionTitle": "Platform architecture",
    "page": 11,
    "route": "/docs"
  },
  {
    "book": "platform",
    "bookTitle": "The platform book",
    "id": "fig-platform-module-weave",
    "file": "module-weave.png",
    "src": "/docs/module-weave.png",
    "caption": "Console modules and the services behind them",
    "section": "platform-platform-architecture",
    "sectionTitle": "Platform architecture",
    "page": 16,
    "route": "/docs"
  },
  {
    "book": "platform",
    "bookTitle": "The platform book",
    "id": "fig-platform-tenancy-entities",
    "file": "tenancy-entities.png",
    "src": "/docs/tenancy-entities.png",
    "caption": "Tenancy and the entity registry",
    "section": "platform-tenancy-and-the-entity-registry",
    "sectionTitle": "Tenancy and the entity registry",
    "page": 16,
    "route": "/docs"
  },
  {
    "book": "platform",
    "bookTitle": "The platform book",
    "id": "fig-platform-queue-lifecycle",
    "file": "queue-lifecycle.png",
    "src": "/docs/queue-lifecycle.png",
    "caption": "Firestore as the job queue — the claim template",
    "section": "platform-runtime-backbone-queue-workers-fan-out-live-config",
    "sectionTitle": "Runtime backbone: queue, workers, fan-out, live config",
    "page": 18,
    "route": "/docs"
  },
  {
    "book": "platform",
    "bookTitle": "The platform book",
    "id": "fig-platform-agent-fabric",
    "file": "agent-fabric.png",
    "src": "/docs/agent-fabric.png",
    "caption": "The agent fabric — one retrieval engine, many surfaces",
    "section": "platform-the-fabric-agents-knowledge-pipelines-apps",
    "sectionTitle": "The fabric: agents, knowledge, pipelines, apps",
    "page": 20,
    "route": "/docs"
  },
  {
    "book": "platform",
    "bookTitle": "The platform book",
    "id": "fig-platform-scopes",
    "file": "scopes.png",
    "src": "/docs/scopes.png",
    "caption": "Scopes — four levels, one engine",
    "section": "platform-knowledge-and-agent-scopes",
    "sectionTitle": "Knowledge and agent scopes",
    "page": 21,
    "route": "/docs"
  },
  {
    "book": "platform",
    "bookTitle": "The platform book",
    "id": "fig-platform-agentos-gate",
    "file": "agentos-gate.png",
    "src": "/docs/agentos-gate.png",
    "caption": "The gate — no model block reaches a side effect without a gate and a capability",
    "section": "platform-the-agentos-gate-model-gate-capability",
    "sectionTitle": "The agentOS gate: model → gate → capability",
    "page": 28,
    "route": "/docs"
  },
  {
    "book": "platform",
    "bookTitle": "The platform book",
    "id": "fig-platform-workflow-invoice",
    "file": "workflow-invoice.png",
    "src": "/docs/workflow-invoice.png",
    "caption": "Invoice intake: IDP with human review",
    "section": "platform-static-and-dynamic-workflows",
    "sectionTitle": "Static and dynamic workflows",
    "page": 30,
    "route": "/docs"
  },
  {
    "book": "platform",
    "bookTitle": "The platform book",
    "id": "fig-platform-workflow-knowledge",
    "file": "workflow-knowledge.png",
    "src": "/docs/workflow-knowledge.png",
    "caption": "Knowledge refresh workflow",
    "section": "platform-static-and-dynamic-workflows",
    "sectionTitle": "Static and dynamic workflows",
    "page": 31,
    "route": "/docs"
  },
  {
    "book": "platform",
    "bookTitle": "The platform book",
    "id": "fig-platform-workflow-streaming",
    "file": "workflow-streaming.png",
    "src": "/docs/workflow-streaming.png",
    "caption": "Call-center compliance stream",
    "section": "platform-static-and-dynamic-workflows",
    "sectionTitle": "Static and dynamic workflows",
    "page": 31,
    "route": "/docs"
  },
  {
    "book": "platform",
    "bookTitle": "The platform book",
    "id": "fig-platform-execution-tiers",
    "file": "execution-tiers.png",
    "src": "/docs/execution-tiers.png",
    "caption": "nQube execution tiers",
    "section": "platform-execution-batch-streaming-tiers",
    "sectionTitle": "Execution: batch, streaming, tiers",
    "page": 33,
    "route": "/docs"
  },
  {
    "book": "platform",
    "bookTitle": "The platform book",
    "id": "fig-platform-improvement-loops",
    "file": "improvement-loops.png",
    "src": "/docs/improvement-loops.png",
    "caption": "The improvement loops — signals, sinks, gates",
    "section": "platform-self-learning-and-improving-loops",
    "sectionTitle": "Self-learning and improving loops",
    "page": 35,
    "route": "/docs"
  },
  {
    "book": "platform",
    "bookTitle": "The platform book",
    "id": "fig-platform-app-builder-spine",
    "file": "app-builder-spine.png",
    "src": "/docs/app-builder-spine.png",
    "caption": "App Builder — one spine from design to operation",
    "section": "platform-app-builder-the-studio-and-operate",
    "sectionTitle": "App Builder: the studio and Operate",
    "page": 36,
    "route": "/docs"
  },
  {
    "book": "platform",
    "bookTitle": "The platform book",
    "id": "fig-platform-provisioning-stages",
    "file": "provisioning-stages.png",
    "src": "/docs/provisioning-stages.png",
    "caption": "Hosted apps — from wizard to live instance",
    "section": "platform-what-the-app-kit-is",
    "sectionTitle": "What the App Kit is",
    "page": 39,
    "route": "/docs"
  },
  {
    "book": "platform",
    "bookTitle": "The platform book",
    "id": "fig-platform-health-layers",
    "file": "health-layers.png",
    "src": "/docs/health-layers.png",
    "caption": "Eight health layers — independent mechanisms",
    "section": "platform-health-checks-eight-layers",
    "sectionTitle": "Health checks: eight layers",
    "page": 44,
    "route": "/docs"
  },
  {
    "book": "platform",
    "bookTitle": "The platform book",
    "id": "fig-platform-fleet-ops",
    "file": "fleet-ops.png",
    "src": "/docs/fleet-ops.png",
    "caption": "Fleet operations — every kit app monitored, scanned and costed",
    "section": "platform-fleet-hosts-and-the-host-agent",
    "sectionTitle": "Fleet hosts and the host agent",
    "page": 47,
    "route": "/docs"
  },
  {
    "book": "platform",
    "bookTitle": "The platform book",
    "id": "fig-platform-cost-flow",
    "file": "cost-flow.png",
    "src": "/docs/cost-flow.png",
    "caption": "Metering and cost — two ledgers meet in the month close",
    "section": "platform-cost-tracking-and-tagging-aws-and-llm",
    "sectionTitle": "Cost tracking and tagging: AWS and LLM",
    "page": 50,
    "route": "/docs"
  },
  {
    "book": "platform",
    "bookTitle": "The platform book",
    "id": "fig-platform-model-tiers",
    "file": "model-tiers.png",
    "src": "/docs/model-tiers.png",
    "caption": "Model tiers — the smartest model only where the task needs it",
    "section": "platform-model-routing-tiers-policy-gateway-and-the-inference-economy",
    "sectionTitle": "Model routing: tiers, policy, gateway and the inference economy",
    "page": 52,
    "route": "/docs"
  },
  {
    "book": "platform",
    "bookTitle": "The platform book",
    "id": "fig-platform-dev-console-flow",
    "file": "dev-console-flow.png",
    "src": "/docs/dev-console-flow.png",
    "caption": "A Dev Console turn — prompt in, pull request and deploy out",
    "section": "platform-dev-console-the-app-that-builds-apps",
    "sectionTitle": "Dev Console — the app that builds apps",
    "page": 54,
    "route": "/docs"
  },
  {
    "book": "platform",
    "bookTitle": "The platform book",
    "id": "fig-platform-dev-routing-decision",
    "file": "dev-routing-decision.png",
    "src": "/docs/dev-routing-decision.png",
    "caption": "Smart routing — a rules engine and a decision model, measured side by side",
    "section": "platform-dev-console-smart-routing-rules-jev-and-the-proof",
    "sectionTitle": "Dev Console smart routing: rules, Jev and the proof",
    "page": 56,
    "route": "/docs"
  },
  {
    "book": "platform",
    "bookTitle": "The platform book",
    "id": "fig-platform-dev-routing-bench",
    "file": "dev-routing-bench.png",
    "src": "/docs/dev-routing-bench.png",
    "caption": "Routing bench — baseline claude-opus-5 versus routed, 30 real sessions per runtime",
    "section": "platform-dev-console-smart-routing-rules-jev-and-the-proof",
    "sectionTitle": "Dev Console smart routing: rules, Jev and the proof",
    "page": 57,
    "route": "/docs"
  },
  {
    "book": "platform",
    "bookTitle": "The platform book",
    "id": "fig-platform-offer-map",
    "file": "offer-map.png",
    "src": "/docs/offer-map.png",
    "caption": "The offer map — packaging follows cost of goods",
    "section": "platform-two-products-three-carts",
    "sectionTitle": "Two products, three carts",
    "page": 59,
    "route": "/docs"
  },
  {
    "book": "platform",
    "bookTitle": "The platform book",
    "id": "fig-platform-sovereign-seams",
    "file": "sovereign-seams.png",
    "src": "/docs/sovereign-seams.png",
    "caption": "Sovereign seams",
    "section": "platform-sovereign-seams-and-the-dual-data-plane",
    "sectionTitle": "Sovereign seams and the dual data plane",
    "page": 61,
    "route": "/docs"
  },
  {
    "book": "platform",
    "bookTitle": "The platform book",
    "id": "fig-platform-gatekeeper-gates",
    "file": "gatekeeper-gates.png",
    "src": "/docs/gatekeeper-gates.png",
    "caption": "The delivery gatekeeper — every gate must pass before a manifest exists",
    "section": "platform-delivery-targets-and-the-gatekeeper",
    "sectionTitle": "Delivery targets and the gatekeeper",
    "page": 65,
    "route": "/docs"
  },
  {
    "book": "platform",
    "bookTitle": "The platform book",
    "id": "fig-platform-hardware-line",
    "file": "hardware-line.png",
    "src": "/docs/hardware-line.png",
    "caption": "Hardware, preloaded with nventr",
    "section": "platform-branded-hardware-preloaded-with-nventr",
    "sectionTitle": "Branded hardware, preloaded with nventr",
    "page": 73,
    "route": "/docs"
  },
  {
    "book": "protocols",
    "bookTitle": "License & deployment protocols",
    "id": "fig-protocols-delivery-landscape",
    "file": "delivery-landscape.png",
    "src": "/docs/delivery-landscape.png",
    "caption": "The delivery landscape — four targets, two buckets, one gate, one ledger",
    "section": "protocols-the-delivery-landscape",
    "sectionTitle": "The delivery landscape",
    "page": 2,
    "route": "/docs"
  },
  {
    "book": "protocols",
    "bookTitle": "License & deployment protocols",
    "id": "fig-protocols-two-buckets",
    "file": "two-buckets.png",
    "src": "/docs/two-buckets.png",
    "caption": "Two buckets, no third state — and the hard floor beneath both",
    "section": "protocols-ownership-two-buckets-named-entities",
    "sectionTitle": "Ownership: two buckets, named entities",
    "page": 4,
    "route": "/docs"
  },
  {
    "book": "protocols",
    "bookTitle": "License & deployment protocols",
    "id": "fig-protocols-gatekeeper-gates",
    "file": "gatekeeper-gates.png",
    "src": "/docs/gatekeeper-gates.png",
    "caption": "The gate sequence — any failure blocks the manifest",
    "section": "protocols-the-delivery-gatekeeper",
    "sectionTitle": "The delivery gatekeeper",
    "page": 7,
    "route": "/docs"
  },
  {
    "book": "protocols",
    "bookTitle": "License & deployment protocols",
    "id": "fig-protocols-sealed-flow",
    "file": "sealed-flow.png",
    "src": "/docs/sealed-flow.png",
    "caption": "Sealed delivery — supplier builds and signs, customer verifies and accepts, the ledger remembers",
    "section": "protocols-sealed-delivery-object-code-only",
    "sectionTitle": "Sealed delivery: object code only",
    "page": 8,
    "route": "/docs"
  },
  {
    "book": "routing",
    "bookTitle": "Smart model routing",
    "id": "fig-routing-routing-loop",
    "file": "routing-loop.png",
    "src": "/docs/routing-loop.png",
    "caption": "The routing loop at a glance — signals in, a tier out, outcomes back into the ledger",
    "section": "routing-the-bill-that-started-it",
    "sectionTitle": "The bill that started it",
    "page": 3,
    "route": "/docs"
  },
  {
    "book": "routing",
    "bookTitle": "Smart model routing",
    "id": "fig-routing-routing-signals",
    "file": "routing-signals.png",
    "src": "/docs/routing-signals.png",
    "caption": "The request state — every signal the engines read, and where it comes from",
    "section": "routing-what-the-router-can-see",
    "sectionTitle": "What the router can see",
    "page": 5,
    "route": "/docs"
  },
  {
    "book": "routing",
    "bookTitle": "Smart model routing",
    "id": "fig-routing-routing-engines",
    "file": "routing-engines.png",
    "src": "/docs/routing-engines.png",
    "caption": "The engines — rules in microseconds, Jev in a quarter second, a pipeline on a budget; the same verdict shape out",
    "section": "routing-three-ways-to-decide",
    "sectionTitle": "Three ways to decide",
    "page": 6,
    "route": "/docs"
  },
  {
    "book": "routing",
    "bookTitle": "Smart model routing",
    "id": "fig-routing-routing-tiers",
    "file": "routing-tiers.png",
    "src": "/docs/routing-tiers.png",
    "caption": "Tiers → models per runtime — three rungs, two runtimes, one picker that bypasses them all",
    "section": "routing-the-tier-ladder",
    "sectionTitle": "The tier ladder",
    "page": 9,
    "route": "/docs"
  },
  {
    "book": "routing",
    "bookTitle": "Smart model routing",
    "id": "fig-routing-routing-loop-detail",
    "file": "routing-loop-detail.png",
    "src": "/docs/routing-loop-detail.png",
    "caption": "Sticky, escalate, cap — the loop around one thread, and the two overrides that beat it",
    "section": "routing-sticky-follow-ups",
    "sectionTitle": "Sticky follow-ups",
    "page": 10,
    "route": "/docs"
  },
  {
    "book": "routing",
    "bookTitle": "Smart model routing",
    "id": "fig-routing-routing-ledger",
    "file": "routing-ledger.png",
    "src": "/docs/routing-ledger.png",
    "caption": "The ledger — increment-only counters per month, and the Cost Report card they draw",
    "section": "routing-devrouting-yyyy-mm",
    "sectionTitle": "devRouting/{YYYY-MM}",
    "page": 11,
    "route": "/docs"
  },
  {
    "book": "routing",
    "bookTitle": "Smart model routing",
    "id": "fig-routing-routing-modes",
    "file": "routing-modes.png",
    "src": "/docs/routing-modes.png",
    "caption": "Modes × permissions — nine seeded profiles, who may pick each, who may edit each, and what each does to the route",
    "section": "routing-conversation-modes",
    "sectionTitle": "Conversation modes",
    "page": 13,
    "route": "/docs"
  },
  {
    "book": "routing",
    "bookTitle": "Smart model routing",
    "id": "fig-routing-routing-pipeline",
    "file": "routing-pipeline.png",
    "src": "/docs/routing-pipeline.png",
    "caption": "A router pipeline — Call input → Switch / Decision → Return; one port lives, the rest are skipped",
    "section": "routing-why-a-graph",
    "sectionTitle": "Why a graph",
    "page": 14,
    "route": "/docs"
  },
  {
    "book": "onboarding",
    "bookTitle": "The onboarding guidebook",
    "id": "fig-loop",
    "file": "onboarding-loop.png",
    "src": "/guide/onboarding-loop.png",
    "caption": "The loop — four maps feed the initiatives, the initiatives are built on the platform and measured, and the map changes again; the numbers are the Blueprint's step rail",
    "section": "onboarding-the-one-idea-in-this-book",
    "sectionTitle": "The one idea in this book",
    "page": 3,
    "route": "/guide"
  },
  {
    "book": "onboarding",
    "bookTitle": "The onboarding guidebook",
    "id": "fig-blueprint",
    "file": "shot-blueprint-map.png",
    "src": "/guide/shot-blueprint-map.png",
    "caption": "The Blueprint in the console — the step rail across the top, the records NoVA has mapped so far on the canvas, and the verbs along the bottom",
    "section": "onboarding-how-nova-runs-this-with-you",
    "sectionTitle": "How NoVA runs this with you",
    "page": 5,
    "route": "/guide"
  },
  {
    "book": "onboarding",
    "bookTitle": "The onboarding guidebook",
    "id": "fig-four-maps",
    "file": "onboarding-four-maps.png",
    "src": "/guide/onboarding-four-maps.png",
    "caption": "A map at a glance — three systems with verdicts, two data stores, two processes, three roles, the links between them, and what NoVA says is still missing",
    "section": "onboarding-systems-what-you-pay-for-and-where-people-live",
    "sectionTitle": "Systems: what you pay for and where people live",
    "page": 6,
    "route": "/guide"
  },
  {
    "book": "onboarding",
    "bookTitle": "The onboarding guidebook",
    "id": "fig-worksheet",
    "file": "onboarding-worksheet.png",
    "src": "/guide/onboarding-worksheet.png",
    "caption": "The process worksheet, filled in for invoicing — the questions in the order NoVA asks them, and the yearly labor figure the answers yield",
    "section": "onboarding-processes-where-the-hours-go",
    "sectionTitle": "Processes: where the hours go",
    "page": 7,
    "route": "/guide"
  },
  {
    "book": "onboarding",
    "bookTitle": "The onboarding guidebook",
    "id": "fig-levers",
    "file": "onboarding-levers.png",
    "src": "/guide/onboarding-levers.png",
    "caption": "The six levers — what each one changes, what it is built from, what it is priced against, and the typical share of the baseline it removes",
    "section": "onboarding-from-a-map-to-a-proposal",
    "sectionTitle": "From a map to a proposal",
    "page": 8,
    "route": "/guide"
  },
  {
    "book": "onboarding",
    "bookTitle": "The onboarding guidebook",
    "id": "fig-build",
    "file": "onboarding-build.png",
    "src": "/guide/onboarding-build.png",
    "caption": "What gets built — an initiative's deliverables across nQube, the App Kit, Integrations, the Training Center and Agents, each linked back to the plan",
    "section": "onboarding-the-platform-one-initiative-at-a-time",
    "sectionTitle": "The platform, one initiative at a time",
    "page": 10,
    "route": "/guide"
  },
  {
    "book": "onboarding",
    "bookTitle": "The onboarding guidebook",
    "id": "fig-pipeline",
    "file": "onboarding-process-pipeline.png",
    "src": "/guide/onboarding-process-pipeline.png",
    "caption": "From a process on the map to a pipeline on nQube — the five invoicing steps become blocks; the judgement step keeps its person, now only for the exceptions",
    "section": "onboarding-your-first-workflow-on-nqube",
    "sectionTitle": "Your first workflow on nQube",
    "page": 11,
    "route": "/guide"
  },
  {
    "book": "onboarding",
    "bookTitle": "The onboarding guidebook",
    "id": "fig-nqube",
    "file": "shot-nqube-canvas.png",
    "src": "/guide/shot-nqube-canvas.png",
    "caption": "The Invoicing pipeline on nQube — drafted by the copilot from the initiative on the map: read the invoices, extract each, validate, send the exceptions to a person, post the rest",
    "section": "onboarding-your-first-workflow-on-nqube",
    "sectionTitle": "Your first workflow on nQube",
    "page": 11,
    "route": "/guide"
  },
  {
    "book": "onboarding",
    "bookTitle": "The onboarding guidebook",
    "id": "fig-initiative",
    "file": "shot-initiative-forecast.png",
    "src": "/guide/shot-initiative-forecast.png",
    "caption": "One initiative in the console — its lever and rationale, its targets on the map, the forecast inputs and the outputs that recompute as you type, and the decision buttons only a person may press",
    "section": "onboarding-the-initiative-over-time",
    "sectionTitle": "The initiative over time",
    "page": 13,
    "route": "/guide"
  },
  {
    "book": "onboarding",
    "bookTitle": "The onboarding guidebook",
    "id": "fig-forecast",
    "file": "onboarding-forecast.png",
    "src": "/guide/onboarding-forecast.png",
    "caption": "The forecast, worked — five inputs pre-filled from the map, six outputs from one model, and the cumulative cash curve crossing zero at payback",
    "section": "onboarding-the-forecast",
    "sectionTitle": "The forecast",
    "page": 13,
    "route": "/guide"
  },
  {
    "book": "onboarding",
    "bookTitle": "The onboarding guidebook",
    "id": "fig-realized",
    "file": "onboarding-realized.png",
    "src": "/guide/onboarding-realized.png",
    "caption": "Forecast against realized, month by month — measured savings from what ran, what a person recorded on top, and the ledger the Impact tab keeps",
    "section": "onboarding-the-realized-column",
    "sectionTitle": "The realized column",
    "page": 14,
    "route": "/guide"
  },
  {
    "book": "onboarding",
    "bookTitle": "The onboarding guidebook",
    "id": "fig-ninety",
    "file": "onboarding-ninety-days.png",
    "src": "/guide/onboarding-ninety-days.png",
    "caption": "The first ninety days — three bands, what happens each week, the deliverable at each milestone, and where the step rail says you are",
    "section": "onboarding-days-1-30-map",
    "sectionTitle": "Days 1–30: map",
    "page": 15,
    "route": "/guide"
  }
];
